require('./aggregatorManageEntitiesAccordion.scss');

// import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Accordion } from 'commonsComponents/accordion';
import { AccordionHeader } from 'commonsComponents/accordionHeader';
import { AccordionBody } from 'commonsComponents/accordionBody';
import { OKIconButton } from 'commonsComponents/OKIconButton';
import { OKButton } from 'components/commons/OKButton/OKButton';
import { LoadingDots } from 'commonsComponents/loadingDots';
import { AggregatorStatus } from 'components/aggregator/aggregatorStatus/aggregatorStatus';

import { getLastNChars } from 'utilities/stringHelper';

import {
  BAD_CREDENTIALS,
  KO,
  PENDING,
  SYNC,
  BAD_SECOND_FACTOR_AUTHENTICATION,
} from 'constants/aggregator/statuses';

const { DELETED } = require('constants/aggregator/tinkStatuses.constants');

import {
  ACCOUNTS,
  CARDS,
  LOANSANDMORTGAGES,
  DEPOSITS,
  INVESTMENTS,
} from 'constants/aggregator/products';

import { LOAN, MORTGAGE, CREDIT, FUND, PENSIONPLAN, SHARES } from 'constants/aggregator/subtypes';

import Toggle from 'components/commons/toggle/toggle';

import {
  recordLink,
  EVENT_ACTIVATE,
  EVENT_DESACTIVATE,
  EVENT_REMOVE,
  PROC_AGGREGATOR,
  PROC_MANAGE_ENTITIES_AGGREGATOR,
  PROC_MANAGE_ACCOUNTS_AGGREGATOR,
} from 'utilities/tagging';

const { formatText } = require('core/i18n').i18n;

class AggregatorManageEntitiesAccordion extends React.PureComponent {
  handleOnToggle = (productId, productType, checked) => {
    const { toggleActive, onHandleDirty, bankId } = this.props;
    toggleActive(productId, productType, checked, bankId);
    onHandleDirty();
    recordLink(
      PROC_AGGREGATOR,
      PROC_MANAGE_ACCOUNTS_AGGREGATOR,
      checked ? EVENT_ACTIVATE : EVENT_DESACTIVATE
    );
  };

  handleOnRemove = bank => {
    const { onHandleDirty, removeEntity } = this.props;

    removeEntity(bank);
    onHandleDirty();
    recordLink(PROC_AGGREGATOR, PROC_MANAGE_ENTITIES_AGGREGATOR, EVENT_REMOVE);
  };

  renderAccount(product) {
    return (
      <div className="aggregator-accordion__body__item__alias__account">
        <i className="aggregator-accordion__body__item__alias__icon icon rebrand-accounts" />
        <div className="aggregator-accordion__body__item__alias__div">
          <div className="aggregator-accordion__body__item__alias__div__name">
            {product.get('alias')}
          </div>
          <div className="aggregator-accordion__body__item__alias__div__number">
            {getLastNChars(product.get('iban', '').toString())}
          </div>
        </div>
      </div>
    );
  }

  renderCard(product) {
    const cardTypeClass = classNames('aggregator-accordion__body__item__alias__icon icon', {
      'rebrand-ecard': product.get('type') == 'E',
      'rebrand-credit-card': product.get('type') != 'E',
    });

    return (
      <div className="aggregator-accordion__body__item__alias__cards">
        <i className={cardTypeClass} />

        <div className="aggregator-accordion__body__item__alias__div">
          <div className="aggregator-accordion__body__item__alias__div__name">
            {product.get('alias')}
          </div>
          <div className="aggregator-accordion__body__item__alias__div__number">
            {getLastNChars(product.get('number', '').toString())}
          </div>
        </div>
      </div>
    );
  }

  renderLoanOrMortgage(product) {
    const cardTypeClass = classNames('aggregator-accordion__body__item__alias__icon icon', {
      'rebrand-mortgages': product.get('subproduct') == MORTGAGE,
      'rebrand-loans': product.get('subproduct') == LOAN,
      'rebrand-credits': product.get('subproduct') == CREDIT,
    });

    return (
      <div className="aggregator-accordion__body__item__alias__loans">
        <i className={cardTypeClass} />
        <div className="aggregator-accordion__body__item__alias__div">
          <div className="aggregator-accordion__body__item__alias__div__name">
            {product.get('alias')}
          </div>
          <div className="aggregator-accordion__body__item__alias__div__number">
            {getLastNChars(product.get('iban', '').toString())}
          </div>
        </div>
      </div>
    );
  }

  renderDeposit(product) {
    return (
      <div className="aggregator-accordion__body__item__alias__deposits">
        <i className="aggregator-accordion__body__item__alias__icon icon rebrand-savings" />
        <div className="aggregator-accordion__body__item__alias__div">
          <div className="aggregator-accordion__body__item__alias__div__name">
            {product.get('alias')}
          </div>
          <div className="aggregator-accordion__body__item__alias__div__number">
            {getLastNChars(product.get('account', '').toString())}
          </div>
        </div>
      </div>
    );
  }

  renderInvestment(product) {
    // <i className="icon rebrand-funds" />
    // <i className="icon rebrand-wallets" />
    // <i className="icon rebrand-plans" />
    const cardTypeClass = classNames('aggregator-accordion__body__item__alias__icon icon', {
      'rebrand-funds': product.get('subproduct') == FUND,
      'rebrand-plans': product.get('subproduct') == PENSIONPLAN,
      'rebrand-wallets': product.get('subproduct') == SHARES,
    });
    return (
      <div className="aggregator-accordion__body__item__alias__investments">
        <i className={cardTypeClass} />
        <div className="aggregator-accordion__body__item__alias__div">
          <div className="aggregator-accordion__body__item__alias__div__name">
            {product.get('alias')}
          </div>
          {product.get('subproduct') !== SHARES ? (
            <div className="aggregator-accordion__body__item__alias__div__number">
              {getLastNChars(product.get('account', product.get('number', '')).toString())}
            </div>
          ) : null}
        </div>
      </div>
    );
  }

  renderError = bankId => {
    const { status } = this.props;

    if (status === PENDING)
      return (
        <td className="aggregator-accordion__header__warning-container">
          <span className="aggregator-accordion__header__warning">
            {formatText('aggregatorManageEntities-updating')}
            <LoadingDots color="dark" size="medium" />
          </span>
        </td>
      );

    if (status !== KO && status !== BAD_CREDENTIALS) return null;

    return [
      <td key="1">
        <span className="aggregator-accordion__header__warning">
          <i className="aggregator-accordion__header__warning__icon icon icon-error" />
          {formatText('aggregatorManageEntities-credentialsError')}
        </span>
      </td>,
      <td key="2" className="aggregator-accordion__header__warning__button-container">
        <OKButton modifier="secondary" to={`/myprofile/global/entities/credentials/${bankId}`}>
          {formatText('aggregatorManageEntities-refreshCredentials')}
        </OKButton>
      </td>,
    ];
  };

  renderProduct = product => {
    const funcMap = {
      [ACCOUNTS]: this.renderAccount,
      [CARDS]: this.renderCard,
      [LOANSANDMORTGAGES]: this.renderLoanOrMortgage,
      [DEPOSITS]: this.renderDeposit,
      [INVESTMENTS]: this.renderInvestment,
    };

    const item =
      product && funcMap[product.get('product')] ? funcMap[product.get('product')](product) : null;

    return product ? (
      <div key={product.get('id')} className="aggregator-accordion__body__item row">
        <div className="aggregator-accordion__body__item__alias col-xs-8">{item}</div>
        <div className="aggregator-accordion__body__item__toggle col-xs-4">
          <Toggle
            checked={product.get('visible')}
            onClick={() =>
              this.handleOnToggle(
                product.get('id'),
                product.get('subproduct'),
                !product.get('visible')
              )
            }
          />
        </div>
      </div>
    ) : null;
  };

  renderBody = () => {
    const {
      products,
      status,
      bankName,
      bankCode,
      bankId,
      getSecondFactorAuth,
      psd2Status,
      bankLogo,
    } = this.props;

    return (
      <React.Fragment>
        <div className="aggregator-accordion__body">
          {products.map(p => p && this.renderProduct(p))}
        </div>
        {status && status !== DELETED && (
          <AggregatorStatus
            bankName={bankName}
            bankStatus={status}
            bankLogo={bankLogo}
            userBankId={bankId}
            bankCode={bankCode}
            deprecated={status === BAD_SECOND_FACTOR_AUTHENTICATION}
            getSecondFactorAuth={getSecondFactorAuth}
          />
        )}
        {psd2Status && psd2Status !== DELETED && (
          <AggregatorStatus
            bankName={bankName}
            bankStatus={psd2Status}
            userBankId={bankId}
            bankLogo={bankLogo}
            bankCode={bankCode}
            deprecated={status === BAD_SECOND_FACTOR_AUTHENTICATION}
            getSecondFactorAuth={getSecondFactorAuth}
          />
        )}
      </React.Fragment>
    );
  };

  render() {
    const { bankName, products, bankId, status } = this.props;
    const disableButton = status === SYNC;

    return (
      <Accordion isExpanded>
        <AccordionHeader name="AccordionHeader">
          <table className="aggregator-accordion__header">
            <td className="aggregator-accordion__header__name-container">
              <span className="aggregator-accordion__header__name">{bankName}</span>
              {!!products.size && (
                <span className="aggregator-accordion__header__number">({products.size})</span>
              )}
            </td>
            {this.renderError(bankId)}
            <td>
              <span className="aggregator-accordion__header__button-div">
                <OKIconButton
                  icon="aggregator-accordion__header__icon icon icon-eliminar"
                  size="medium"
                  onClick={() => this.handleOnRemove(bankId)}
                  disabled={disableButton}
                />
              </span>
            </td>
          </table>
        </AccordionHeader>
        <AccordionBody name="AccordionBody">{this.renderBody()}</AccordionBody>
      </Accordion>
    );
  }
}

AggregatorManageEntitiesAccordion.propTypes = {
  bankName: PropTypes.string,
  bankCode: PropTypes.string,
  bankId: PropTypes.string,
  products: PropTypes.object,
  removeEntity: PropTypes.func,
  toggleActive: PropTypes.func,
  onHandleDirty: PropTypes.func,
  status: PropTypes.string,
  psd2Status: PropTypes.string,
  bankLogo: PropTypes.string,
  getSecondFactorAuth: PropTypes.func,
    isAggregatorTink: PropTypes.bool
};

export { AggregatorManageEntitiesAccordion };
